import React, { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import Spinners from "./Spinner"
import heic2any from "heic2any"
import PdfViewer from "./PdfView"
const MediaView = () => {
  const location = useLocation()
  const locationState = location.state || {}
  const { fileurl } = locationState
  const [convertedUrl, setConvertedUrl] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const loadAndConvertHeic = async () => {
      if (fileurl && fileurl.toLowerCase().endsWith(".heic")) {
        try {
          const response = await fetch(fileurl)
          if (!response.ok) throw new Error("Image not found or inaccessible.")

          const heicBlob = await response.blob()

          const jpegBlob = await heic2any({
            blob: heicBlob,
            toType: "image/jpeg",
            quality: 0.9,
          })

          const imageUrl = URL.createObjectURL(jpegBlob)
          setConvertedUrl(imageUrl)
        } catch (err) {
          console.error("Conversion error:", err)
          setError("Failed to load image.")
        } finally {
          setLoading(false)
        }
      } else {
        setLoading(false) 
      }
    }

    if (fileurl) {
      loadAndConvertHeic()
    }
  }, [fileurl])

  const handleIframeLoad = () => {
    setLoading(false)
  }

  const renderMediaPreview = () => {
    const ext = fileurl?.split(".").pop().toLowerCase()

    switch (ext) {
      case "jpg":
      case "jpeg":
      case "png":
      case "gif":
        return (
          <img
            src={fileurl}
            alt="media"
            width="100%"
            onLoad={handleIframeLoad}
            className="rounded-2"
          />
        )
      // case "heic":
      //   if (convertedUrl) {
      //     return (
      //       <img
      //         src={convertedUrl}
      //         alt="converted HEIC"
      //         width="100%"
      //         onLoad={handleIframeLoad}
      //         className="rounded-2"
      //       />
      //     )
      //   } else {
      //     return error ? <p>{error}</p> : <Spinners />
      //   }
      case "doc":
      case "docx":
      case "xls":
      case "xlsx":
      case "ppt":
      case "pptx":
      case "pdf":
        return (
          // <PdfViewer fileUrl={fileurl} />
          <iframe
            src={`https://docs.google.com/viewer?url=${encodeURIComponent(
              fileurl
            )}&embedded=true`}
            width="100%"
            height="650px"
            title="document"
            onLoad={handleIframeLoad}
          />
        )
      case "txt":
        return (
          <iframe
            src={`data:text/plain;charset=utf-8,${encodeURIComponent(fileurl)}`}
            width="100%"
            height="600px"
            title="text file"
            onLoad={handleIframeLoad}
          />
        )
      case "zip":
      case "rar":
        return <h6>Archive File: {fileurl}</h6>
      case "mp3":
      case "3gp":
        return (
          <audio controls>
            <source src={fileurl} type={`audio/${ext}`} />
            Your browser does not support the audio element.
          </audio>
        )
      default:
        return <h6>Unsupported file type. Please contact the admin.</h6>
    }
  }

  return (
    <div className="page-content">
      {loading && (
        <div>
          <Spinners />
        </div>
      )}

      <div>
        <a
          href={fileurl}
          download={
            fileurl
          }
          className="btn btn-primary position-absolute me-2 top-0 end-0"
          style={{ marginTop: "90px" }}
        >
          Download
        </a>
      </div>

      <div
        className="d-flex justify-content-center"
        style={{ marginTop: "50px" }}
      >
        {fileurl ? (
          <div
            style={{
              display: loading ? "none" : "block",
              width: "100%",
              maxWidth: "600px",
            }}
          >
            {renderMediaPreview()}
          </div>
        ) : (
          "No File to preview"
        )}
      </div>
    </div>
  )
}

export default MediaView
